export default __webpack_public_path__ + "4929e8f7c89557926cdc7c221abd37e8.svg";